import React from 'react';
import HeaderSortDisplay from './HeaderSortDisplay';

const createHeaderComponent = (column, getGridProps) => {
    const HeaderComponent = () => (
        <div>
            { column.title || '' }
            { column.sortable && <HeaderSortDisplay styles={ getGridProps().styles } /> }
        </div>
    );

    return HeaderComponent;
};

export default createHeaderComponent;
